const bannerHero = () => {

    const moduloId = `#banner-hero`;

    let formLead = () => {

        $(`${moduloId} #formWrapper input[type=text]`).on(`focusin`, function() {
            $(this).prev().addClass('active-label');
        });

        $(`${moduloId} #formWrapper input[type=text]`).on(`focusout`, function() {

            if ( $(this).val().trim() === "" ) {
                $(this).prev().removeClass('active-label');
            } else {
                $(this).prev().addClass('active-label');
            }
        });
    }

    let init = () => {
        formLead();
    }

    return {
       init: init
    };

};
$(window).on("load", bannerHero().init);